import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateProductGroupRequest, OrgUnitResponse } from '../models/org-unit.models';

@Injectable({
  providedIn: 'root',
})
export class ProductGroupService {
  private readonly serviceRegionsUrl = `${environment.baseUrl}organizations/service-regions`;

  constructor(private readonly http: HttpClient) {}

  getProductGroupsByServiceRegion(serviceRegionId: string): Observable<OrgUnitResponse[]> {
    return this.http.get<OrgUnitResponse[]>(
      `${this.serviceRegionsUrl}/${serviceRegionId}/product-groups`
    );
  }

  createProductGroup(body: CreateProductGroupRequest): Observable<OrgUnitResponse> {
    return this.http.post<OrgUnitResponse>(`${this.serviceRegionsUrl}/product-groups`, body);
  }
}
